import { useState } from "react";

interface LocalStorageAccessor<T> {
    value: T;
    setValue(newVal: T): void;
}

export default function useLocalStorageValue<T>(key: string, defaultValue: T): LocalStorageAccessor<T> {
    const [val, setVal] = useState<T>(() => {
        const asString = localStorage.getItem(key);
        if (asString != null && asString.length > 0) {
            return JSON.parse(asString);
        } else {
            return defaultValue;
        }
    });

    function setValue(newVal: T): void {
        localStorage.setItem(key, JSON.stringify(newVal));
        setVal(newVal);
    }

    return {
        value: val,
        setValue
    }
}